import React, { useMemo } from 'react';
import PlayingCard from './PlayingCard';
import {
  flyOrigin,
  trickOffset,
  PLAY_FLY_MS,
  TRICK_GATHER_MS,
} from '../utils/trickAnimation';

function TrickCardSprite({
  sprite,
  cardW,
  cardH,
  trickDist,
  handReach,
  onFlyComplete,
  onGatherComplete,
}) {
  const flyFrom = flyOrigin(sprite.visualSeat, handReach);
  // Land at cardinal seat direction (N/E/S/W of table center)
  const flyDest = trickOffset(sprite.visualSeat, trickDist);

  const handleAnimationEnd = (e) => {
    if (e.target !== e.currentTarget) return;
    const name = e.animationName || '';
    if (sprite.phase === 'flying' && name.includes('spades-play-fly')) {
      onFlyComplete?.(sprite.id);
    } else if (sprite.phase === 'gathering' && name.includes('spades-trick-gather')) {
      onGatherComplete?.(sprite.id);
    }
  };

  const className = useMemo(() => {
    const parts = ['spades-trick-sprite'];
    if (sprite.phase === 'flying') {
      parts.push('spades-trick-sprite--flying', `spades-trick-sprite--${sprite.visualSeat}`);
    } else if (sprite.phase === 'gathering') {
      parts.push('spades-trick-sprite--gathering');
    } else {
      parts.push('spades-trick-sprite--resting');
    }
    return parts.join(' ');
  }, [sprite.phase, sprite.visualSeat]);

  const style = useMemo(() => {
    if (sprite.phase === 'flying') {
      return {
        '--fly-x0': `${flyFrom.x}px`,
        '--fly-y0': `${flyFrom.y}px`,
        '--fly-r0': `${flyFrom.rot}deg`,
        '--fly-x1': `${flyDest.x}px`,
        '--fly-y1': `${flyDest.y}px`,
        '--fly-r1': `${flyDest.rot}deg`,
        '--play-fly-ms': `${PLAY_FLY_MS}ms`,
        zIndex: sprite.layerIndex + 2,
      };
    }
    if (sprite.phase === 'gathering') {
      return {
        '--gx0': `${sprite.gx0}px`,
        '--gy0': `${sprite.gy0}px`,
        '--gr0': `${sprite.gr0}deg`,
        '--gxs': `${sprite.gxs}px`,
        '--gys': `${sprite.gys}px`,
        '--gr1': `${sprite.gr1}deg`,
        '--gx1': `${sprite.gx1}px`,
        '--gy1': `${sprite.gy1}px`,
        '--trick-gather-ms': `${TRICK_GATHER_MS}ms`,
        zIndex: sprite.zIndex,
      };
    }
    return {
      '--off-x': `${sprite.restX}px`,
      '--off-y': `${sprite.restY}px`,
      '--off-r': `${sprite.restRot}deg`,
      zIndex: sprite.layerIndex + 2,
    };
  }, [sprite, flyFrom, flyDest]);

  const listenEnd = sprite.phase === 'flying' || sprite.phase === 'gathering';

  return (
    <PlayingCard
      card={sprite.card}
      width={cardW}
      height={cardH}
      className={className}
      style={style}
      onAnimationEnd={listenEnd ? handleAnimationEnd : undefined}
    />
  );
}

export default TrickCardSprite;